<template>
	<div class="p-col-12 p-grid">
		<div class="p-col-12 p-lg-6" :class="[commonService.isMobile() ? 'text-box-mobile' : 'text-box']">
			<p class="login-subtitle">Join the TiroLibre's Affiliate Program</p>
			<p class="login-text justified">Tirolibre uses an affiliation system to identify emerging talents from minor clubs throughout the territory. Thanks to the collaboration with coaches, directors, and presidents who know the player directly and have seen him grow, the platform is able to offer a credible evaluation of his potential. This allows professional clubs to discover new talents and have a reliable reference on their quality, speeding up the selection process and reducing the risk of costly mistakes.</p>
			<p class="login-text">Register now and enjoy the following benefits:</p>
			<p class="login-text" style="margin-top: -0px">- Access to emerging talents from minor clubs</p>
			<p class="login-text margin-list">- Have a reliable reference on the quality of players</p>
			<p class="login-text margin-list">- Trade without commission</p>
			<p class="login-text margin-list">- Speed up the selection process</p>
			<div v-if="!commonService.isMobile()" :class="isSmallScreen()? 'p-col-5 button-box' : 'p-lg-3 button-box'" style="padding: 0px">
				<Button label="Become an associate" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
		<div class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomeAffiliateImageUrl()" alt="" style="width: 100%">
				</div>
			</div>
			<div v-if="commonService.isMobile()" class="p-col-6 button-box-mobile" style="margin-top: -30px; margin-bottom: 30px">
				<Button label="Become an associate" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
	</div>
</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		toLogin() {
			this.$router.push("/login");
		},
		isSmallScreen() {
			return screen.width <= 1600 ? true : false;
		},
	},
};
</script>

<style scoped>
.justified {
	text-align: justify;
	text-justify: inter-word;
}

.login-title {
	margin-top: -15px;
	font-size: 65px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -80px;
	font-size: xx-large;
	font-weight: bold;
}

.login-text {
	margin-top: 10px;
	font-size: 19px;
}

.text-box {
	margin: auto;
	padding-left: 50px;
}

.text-box-mobile {
	margin: auto;
}

.button-box {
	margin-top: 20px;
}

.button-box-mobile {
	margin: auto;
}

.margin-list {
	margin-top: -20px;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.login-title {
		margin-top: -15px;
		font-size: 45px;
		font-weight: bold;
	}

	.login-subtitle {
		margin-top: -0px;
		font-size: x-large;
		font-weight: bold;
	}

	.login-text {
		margin-top: 10px;
		font-size: 16px;
	}

	.margin-list {
		margin-top: -15px;
	}
}
</style>